import { Component, inject } from '@angular/core';
import {NgIf, NgFor} from '@angular/common';
import {ToastPackage, ToastrService, Toast} from 'ngx-toastr';
import {TranslatePipe} from '@ngx-translate/core';

export interface InfoboxLine {
  label?: string;
  value: string;
}

export interface InfoboxData {
  title: string;
  lines: InfoboxLine[];
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[event-calendar-infobox]',
  standalone: true,
  imports: [NgIf, NgFor, TranslatePipe],
  styles: [`:host { width: fit-content !important; }`],
  templateUrl: './event-calendar-infobox.component.html',
})
export class EventCalendarInfoboxComponent extends Toast {
  /** Set by the caller via `toastrService.show(undefined, undefined, {payload})`. */
  public get data(): InfoboxData | undefined {
    return this.toastPackage.config.payload as InfoboxData | undefined;
  }

  constructor() {
    const toastrService = inject(ToastrService);
    const toastPackage = inject(ToastPackage);

    super(toastrService, toastPackage);
  }

  public close(event: Event) {
    this.remove();
    event.stopPropagation();
    this.toastPackage.triggerAction();
    return false;
  }
}
